<template>
  <div>
    <el-form label-position="left" label-width="110px" ref="form" size="small" v-model="form">
      <div class="container">
        <el-form-item label="统一配送费">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入配送费" v-model="defaultrow.fee">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
            <el-col span="4" style="margin-left:10px;">
              <el-button @click="onUpdateDefault" type="primary">保存</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="特殊地区配送费">
          <el-row :key="row.id" style="margin-bottom: 5px;" v-for="row in list">
            <el-col span="3">
              <el-input disabled :value="row.province"></el-input>
            </el-col>
            <el-col span="3" style="margin-left: 10px; margin-top: -0.9px;">
              <el-input disabled :value="row.fee / 100">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
            <el-col class="c" span="1">
              <i @click="onClickUpdate(row)" class="el-icon-edit"></i>
            </el-col>
            <el-col class="c" span="1">
              <i @click="onClickDelete(row)" class="el-icon-delete"></i>
            </el-col>
          </el-row>

          <el-col span="2">
            <el-button @click="onClickAdd" type="text">添加新地区</el-button>
          </el-col>
        </el-form-item>

        <el-dialog :title="!row.id ? '添加' : '修改'" :visible.sync="showEdit" width="30%" :before-close="handleClose">
          <el-row>
            <el-col span="10">
              <el-select :disabled="row.id" placeholder="选择省份" size="small" v-model="row.province">
                <el-option :key="item" :label="item" :value="item" v-for="item in province"></el-option>
              </el-select>
            </el-col>
            <el-col span="10" style="margin-left:10px;">
              <el-input placeholder="配送费" size="small" v-model="row.fee">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showEdit = false">取 消</el-button>
            <el-button type="primary" @click="onAdd" v-if="!row.id">添加</el-button>
            <el-button type="primary" @click="onUpdate" v-if="row.id">更新</el-button>
          </span>
        </el-dialog>

        <div class="button-wrap"></div>
      </div>
    </el-form>

    <!--物流公司 -->
    <el-form label-position="left" label-width="110px" ref="form" size="small" v-model="form">
      <div class="container">
        <el-form-item label="签约物流公司">
          <el-row :key="row.id" style="margin-bottom: 5px;" v-for="row in deliveryList">
            <el-col span="3">
              <el-input disabled :value="row.deliveryname"></el-input>
            </el-col>
            <el-col span="3" style="margin-left: 10px;">
              <el-input disabled :value="row.bizid"></el-input>
            </el-col>
            <el-col class="c" span="1">
              <i @click="onClickDeleteDelivery(row)" class="el-icon-delete"></i>
            </el-col>
          </el-row>

          <el-row>
            <el-col span="2">
              <el-button @click="onClickAddDelivery" type="text">添加电子面单账号</el-button>
            </el-col>
          </el-row>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            此操作是可选的, 仅当您已经签约了物流公司才需添加. 即使不添加, 仍可以在发货时自动呼叫快递员.
          </div>
          <div style="color: #999; font-size: 10px;">
            <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
            您必须先将电子面单账号和密钥添加进
            <a href="https://mp.weixin.qq.com" style="color: #ff4f4f; margin-left: 3px;" targe="_blank">微信小程序后台</a>
          </div>
        </el-form-item>

        <el-dialog :title="'添加'" :visible.sync="showEditDelivery" width="30%" :before-close="handleClose">
          <el-row>
            <el-col span="10">
              <el-select placeholder="选择快递公司" size="small" v-model="deliveryid">
                <el-option :key="item" :label="item.deliveryname" :value="item.deliveryid" v-for="item in wxdeliverylist"></el-option>
              </el-select>
            </el-col>
            <el-col span="10" style="margin-left:10px;">
              <el-input placeholder="电子面单账号" size="small" v-model="bizid"></el-input>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showEditDelivery = false">取 消</el-button>
            <el-button type="primary" @click="onAddDelivery">添加</el-button>
          </span>
        </el-dialog>

        <div class="button-wrap"></div>
      </div>
    </el-form>

    <!-- 发件人 -->
    <el-form label-position="left" label-width="110px" ref="form" size="small" v-model="form">
      <div class="container">
        <el-form-item label="发件人名称">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入名称" v-model="store.sendername"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="手机号">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入手机号" v-model="store.sendermobile"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="地址">
          <el-row>
            <el-col span="8">
              <el-cascader style="width: 100%;" v-model="pcd" :options="ssx"></el-cascader>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- <el-form-item label="省份">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入省份" v-model="store.senderprovince"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="城市">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入城市" v-model="store.sendercity"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="区县">
          <el-row>
            <el-col span="4">
              <el-input placeholder="请输入区县" v-model="store.senderdistrict"></el-input>
            </el-col>
          </el-row>
        </el-form-item>-->
        <el-form-item label="详细地址">
          <el-row>
            <el-col span="8">
              <el-input placeholder="请输入详细地址" v-model="store.senderaddress"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label>
          <el-row>
            <el-col span="4">
              <el-button @click="onUpdateStore" type="primary">保存</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="button-wrap"></div>
      </div>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc } from '../../../service/index';
import { M } from '../../../service/grpc';
import { getToken } from '../../../service/helper';
import province from '../../../assets/province';
import ssx from '../../../assets/ssx';
import { getCachedStore } from '../../../router/auth';

export default {
  components: {
  },
  data() {
    return {
      showProDialog: false,
      token: '',
      defaultrow: {},
      row: {},
      list: [],
      showEdit: false,
      province,
      ssx,
      pcd: [],

      // 物流公司
      wxdeliverylist: [],
      deliveryList: [],
      deliveryid: '',
      bizid: '',
      showEditDelivery: false,

      // 发件人
      store: {},
    };
  },
  async created() {
    this.token = getToken();
    var store = await getCachedStore();
    rpc(
      'StoreShippingService.GetShippingList',
      M('ShippingListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      const defaultrow = res.shippinglistList.find(v => v.province == '默认');
      defaultrow.fee = defaultrow.fee / 100;
      this.defaultrow = defaultrow;
      this.list = res.shippinglistList.filter(v => v.province != '默认');
    });

    rpc(
      'StoreDeliveryService.GetDeliveryList',
      M('DeliveryListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      this.deliveryList = res.deliverylistList;
    });

    rpc(
      'StoreDeliveryService.GetAllWxDeliveryList',
        M('Token', { token: this.token })
    ).then(res => {
      this.wxdeliverylist = res.wxdeliverylistList;
    });

    rpc('StoreAuthService.GetStore', M('Token', { token: this.token })).then(res => {
      if (res.senderprovince && res.sendercity && res.senderdistrict) {
        this.pcd = [res.senderprovince, res.sendercity, res.senderdistrict];
      }
      this.store = res;
    });
  },
  methods: {
    // 配送费
    onUpdateDefault() {
      const row = JSON.parse(JSON.stringify(this.defaultrow));
      row.fee = parseInt(row.fee * 100);
      rpc(
        'StoreShippingService.UpdateShipping',
        M('ShippingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          shipping: M('Shipping', row)
        })
      ).then(res => {
        res.fee = res.fee / 100;
        this.defaultrow = res;
      });
    },
    onClickAdd() {
      this.row = {};
      this.showEdit = true;
    },
    onClickUpdate(row) {
      row = JSON.parse(JSON.stringify(row));
      row.fee = row.fee / 100;
      this.row = row;
      this.showEdit = true;
    },
    onClickDelete(row) {
      rpc(
        'StoreShippingService.DeleteShipping',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
      });
    },
    onAdd() {
      const row = JSON.parse(JSON.stringify(this.row));
      row.fee = parseInt(row.fee * 100);
      rpc(
        'StoreShippingService.CreateShipping',
        M('ShippingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          shipping: M('Shipping', row)
        })
      ).then(res => {
        this.list.splice(0, 0, res);
        this.showEdit = false;
      });
    },
    onUpdate() {
      const row = JSON.parse(JSON.stringify(this.row));
      row.fee = parseInt(row.fee * 100);
      rpc(
        'StoreShippingService.UpdateShipping',
        M('ShippingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          shipping: M('Shipping', row)
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === row.id), 1, res);
        this.showEdit = false;
      });
    },

    // 物流公司
    onClickAddDelivery() {
      this.showEditDelivery = true;
      this.bizid = '';
    },
    onClickDeleteDelivery(row) {
      rpc(
        'StoreDeliveryService.DeleteDelivery',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      ).then(res => {
        this.deliveryList.splice(this.deliveryList.findIndex(v => v.id === row.id), 1);
      });
    },
    onAddDelivery() {
      rpc(
        'StoreDeliveryService.CreateDelivery',
        M('DeliveryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          delivery: M('Delivery', {
            deliveryid: this.deliveryid,
            deliveryname: wxdeliverylist.find(v => v.deliveryid === this.deliveryid).deliveryname,
            bizid: this.bizid
          })
        })
      ).then(res => {
        this.deliveryList.splice(0, 0, res);
        this.showEditDelivery = false;
      });
    },

    // 发件人
    onUpdateStore() {
      if (!this.pcd.length) {
        this.$message({
          message: '请选择地址'
        });
        return;
      }

      this.store.senderprovince = this.pcd[0];
      this.store.sendercity = this.pcd[1];
      this.store.senderdistrict = this.pcd[2];

      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...this.store,
            businesshoursList: this.store.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: this.store.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      });
    }
  }
};
</script>

<style scoped>
.c {
  text-align: center;
  cursor: pointer;
}
.button-wrap {
  margin: 0;
}

.pro-tag {
  padding: 3px 5px;
  border-radius: 3px;
  background-color: #f5efe8;
  color: #c09c4a;
  font-size: 10px;
  margin-left: 10px;
}
.pro-text {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 5px;
}

.pro-triangle {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 2px;
}
</style>
